import React from 'react'
import '../../styles/Expertise/ExpertiseDPEMention.css'
import { Accordion, Col, Row } from 'react-bootstrap'
import { Fade } from 'react-awesome-reveal'
import expertiseDPEMentionSection1 from '../../assets/expertise/expertise-dpe-mention-section1.jpg'
import expertiseDPEMentionSection2 from '../../assets/expertise/expertise-dpe-mention-section2.jpg'
import expertiseDPEMentionSection3 from '../../assets/expertise/expertise-dpe-mention-section3.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function ExpertiseDPEMention() {

    const section4Accordion1Data = [
        {
            title: "Consultation initiale",
            text: "Discussion de vos besoins et des spécificités de votre bâtiment avec E5M Diagnostics."
        }, {
            title: "Visite et évaluation sur site",
            text: "Un diagnostiqueur certifié avec mention réaliser une visite approfondie de votre bâtiment pour collecter les données nécessaires à l’évaluation."
        }, {
            title: "Analyse et rapport ",
            text: "Les informations recueillies sont analysées pour établir le DPE avec mention, qui comprend des recommandations pour améliorer la performance énergétique du bâtiment."
        }, {
            title: "Livraison du rapport",
            text: "E5M Diagnostics vous fournit un rapport détaillé, incluant la classification énergétique de votre bâtiment et des propositions d’amélioration."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic DPE avec mention - E5M Diagnostics" />
                <meta name="description" content="Diagnostic DPE avec mention sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic DPE avec mention - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic DPE avec mention sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-DPE-avec-mentions" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-DPE-avec-mentions" />
            </Helmet>

            <BrowserView>
                <div id='expertiseDPEMention'>
                    <div id='header'>
                        <div id='expertiseDPEMentionHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Diagnostic DPE avec mention</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='expertiseDPEMentionSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseDPEMentionSection1Left'>
                                    <div className='sectionText'>
                                        Le Diagnostic de Performance Énergétique (DPE) avec mention est une évaluation de la performance énergétique d’un bâtiment avancée, qui va au-delà de la norme DPE. Ce diagnostic spécifique est requis pour certains types de bâtiments complexes,
                                        tels que les bâtiments tertiaires (bureaux, commerces, hôtels, etc.) ou publics, qui présentent des systèmes énergétiques et des usages plus complexes que les logements résidentiels. E5M Diagnostics, grâce à son expertise et à ses diagnostiqueurs
                                        certifiés, offre un service de diagnostic DPE avec mention, permettant d’obtenir une évaluation précise et détaillée de la performance énergétique de ces bâtiments.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertiseDPEMentionSection1Right'>
                                    <img src={expertiseDPEMentionSection1} id='expertiseDPEMentionSection1Image' alt='expertise-dpe-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseDPEMentionSection2'>
                        <Col sm={6}>
                            <div id='expertiseDPEMentionSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={expertiseDPEMentionSection2} className='expertiseDPEMentionSection2Image' alt='expertise-dpe-section2' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertiseDPEMentionSection2Right'>
                                    <h1 className='sectionTitle'>Qu'est-ce que le Diagnostic DPE avec Mention ?</h1>
                                    <div className='sectionText'>
                                        C’est une version approfondie du DPE classique, destinée aux bâtiments autres que d’habitation, qui nécessite une expertise spécifique en raison de leur complexité. Ce diagnostic comprend une analyse détaillée des systèmes de chauffage,
                                        de climatisation, de ventilation, d’éclairage et des autres équipements énergétiques du bâtiment.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseDPEMentionSection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertiseDPEMentionSection3Left'>
                                    <h1 className='sectionTitle'>Qui doit demander la réalisation d'un DPE avec Mention ?</h1>
                                    <div className='sectionText'>
                                        La réalisation de ce diagnostic est obligatoire pour les propriétaires ou les gestionnaires de bâtiments tertiaires ou publics lors de la vente, de la location, ou pour répondre à certaines obligations réglementaires spécifiques à ces
                                        types de bâtiments. Cela concerne également les parties communes de certains immeubles résidentiels complexes.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertiseDPEMentionSection3Right'>
                                    <img src={expertiseDPEMentionSection3} id='expertiseDPEMentionSection3Image' alt='expertise-dpe-section3' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertiseDPEMentionSection4'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertiseDPEMentionSection4Left'>
                                    <h1 className='sectionTitle'>Comment faire réaliser ce Diagnostic ?</h1>
                                    <div className='sectionText'>
                                        Pour faire réaliser un DPE avec mention, il est essentiel de s’adresser à un diagnostiqueur professionnel certifié disposant de la mention spécifique pour les bâtiments complexes. E5M Diagnostics propose une démarche claire et efficace :
                                    </div>
                                    <div className='sectionAccordion'>
                                        <Accordion>
                                            {section4Accordion1Data.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertiseDPEMentionSection4Right'>
                                    <h1 className='sectionTitle'>Quand doit-on demander un DPE avec Mention ?</h1>
                                    <div className='sectionText'>
                                        Le DPE avec mention doit être réalisé :
                                    </div>
                                    <div className='sectionText'>
                                        <ul>
                                            <li>Avant la mise en vente ou en location d’un bâtiment tertiaire ou public.</li>
                                            <li>Lors de certaines transactions spécifiques ou à la demande de l’administration dans le cadre de réglementations environnementales.</li>
                                            <li>Pour les bâtiments neufs ou les bâtiments faisant l’objet de travaux importants, afin de vérifier la conformité avec les normes énergétiques en vigueur.</li>
                                        </ul>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='expertiseDPEMentionSection5'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Evaluation de la performance énergétique</h1>
                            <div className='sectionText'>
                                Ce diagnostic est un outil précieux pour les propriétaires et gestionnaires de bâtiments tertiaires ou publics, permettant d’identifier les moyens d’améliorer l’efficacité énergétique et de réduire les coûts opérationnels. En sélectionnant
                                E5M Diagnostics pour votre DPE avec mention, vous bénéficiez de l’expertise de professionnels certifiés, capables de vous guider vers une meilleure performance énergétique de votre bâtiment.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='expertiseDPEMention'>
                    <div id='header'>
                        <div id='expertiseDPEMentionHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic DPE avec mention</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='expertiseDPEMentionSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <div className='sectionTextMobile'>
                                Le Diagnostic de Performance Énergétique (DPE) avec mention est une évaluation de la performance énergétique d’un bâtiment avancée, qui va au-delà de la norme DPE. Ce diagnostic spécifique est requis pour certains types de bâtiments complexes,
                                tels que les bâtiments tertiaires (bureaux, commerces, hôtels, etc.) ou publics, qui présentent des systèmes énergétiques et des usages plus complexes que les logements résidentiels. E5M Diagnostics, grâce à son expertise et à ses diagnostiqueurs
                                certifiés, offre un service de diagnostic DPE avec mention, permettant d’obtenir une évaluation précise et détaillée de la performance énergétique de ces bâtiments.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={expertiseDPEMentionSection1} id='expertiseDPEMentionSection1ImageMobile' alt='expertise-dpe-section1' />
                        </Fade>
                    </div>
                    <div id='expertiseDPEMentionSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={expertiseDPEMentionSection2} className='expertiseDPEMentionSection2ImageMobile' alt='expertise-dpe-section2' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Qu'est-ce que le Diagnostic DPE avec Mention ?</h1>
                            <div className='sectionTextMobile'>
                                C’est une version approfondie du DPE classique, destinée aux bâtiments autres que d’habitation, qui nécessite une expertise spécifique en raison de leur complexité. Ce diagnostic comprend une analyse détaillée des systèmes de chauffage,
                                de climatisation, de ventilation, d’éclairage et des autres équipements énergétiques du bâtiment.
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseDPEMentionSection3Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Qui doit demander la réalisation d'un DPE avec Mention ?</h1>
                            <div className='sectionTextMobile'>
                                La réalisation de ce diagnostic est obligatoire pour les propriétaires ou les gestionnaires de bâtiments tertiaires ou publics lors de la vente, de la location, ou pour répondre à certaines obligations réglementaires spécifiques à ces
                                types de bâtiments. Cela concerne également les parties communes de certains immeubles résidentiels complexes.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={expertiseDPEMentionSection3} id='expertiseDPEMentionSection3ImageMobile' alt='expertise-dpe-section3' />
                        </Fade>
                    </div>
                    <div id='expertiseDPEMentionSection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Comment faire réaliser ce Diagnostic ?</h1>
                            <div className='sectionTextMobile'>
                                Pour faire réaliser un DPE avec mention, il est essentiel de s’adresser à un diagnostiqueur professionnel certifié disposant de la mention spécifique pour les bâtiments complexes. E5M Diagnostics propose une démarche claire et efficace :
                            </div>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section4Accordion1Data.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Quand doit-on demander un DPE avec Mention ?</h1>
                            <div className='sectionTextMobile'>
                                Le DPE avec mention doit être réalisé :
                            </div>
                            <div className='sectionTextMobile'>
                                <ul>
                                    <li>Avant la mise en vente ou en location d’un bâtiment tertiaire ou public.</li>
                                    <li>Lors de certaines transactions spécifiques ou à la demande de l’administration dans le cadre de réglementations environnementales.</li>
                                    <li>Pour les bâtiments neufs ou les bâtiments faisant l’objet de travaux importants, afin de vérifier la conformité avec les normes énergétiques en vigueur.</li>
                                </ul>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertiseDPEMentionSection5Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Evaluation de la performance énergétique</h1>
                            <div className='sectionTextMobile'>
                                Ce diagnostic est un outil précieux pour les propriétaires et gestionnaires de bâtiments tertiaires ou publics, permettant d’identifier les moyens d’améliorer l’efficacité énergétique et de réduire les coûts opérationnels. En sélectionnant
                                E5M Diagnostics pour votre DPE avec mention, vous bénéficiez de l’expertise de professionnels certifiés, capables de vous guider vers une meilleure performance énergétique de votre bâtiment.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default ExpertiseDPEMention